export default __webpack_public_path__ + "static/media/under-development.2a074307.svg";